const isTrainerCourseComplete = (course) =>
    Boolean(course?.courseCompletionDate || course?.certificateGenerated === true);

const isTrainerCertificateApproved = (course) =>
    ["COMPLETED", "APPROVED", "COMPLETE"].includes(
        String(course?.certificateApprovalStatus || "").trim().toUpperCase()
    );

const hasTrainerTrainingEnded = (course, now = new Date()) => {
    if (!course?.program?.endDate) return true;
    const end = new Date(course.program.endDate);
    const today = new Date(now);
    end.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    return end <= today;
};

const canGenerateTrainerCertificate = (course, now) =>
    isTrainerCourseComplete(course) && hasTrainerTrainingEnded(course, now);

const canApproveTrainerCertificate = (course) =>
    canGenerateTrainerCertificate(course) && !isTrainerCertificateApproved(course);

export {isTrainerCourseComplete, canGenerateTrainerCertificate, canApproveTrainerCertificate};
